<div class="panel__content no-padding">
    <div style="margin-left: 39%;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
    </div>
    <table *ngIf="!loading" class="table table--full-width table--striped table--hover">
        <thead>
            <tr>
                <th>{{'Implement Type' | translate | async}}</th>
                <th>{{'Implement' | translate | async}}</th>
                <th>{{'Model' | translate | async}}</th>
                <th>{{'Approval Request' | translate | async}}</th>
                <th>{{'Approval Response' | translate | async}}</th>
                <th>{{'Start Date' | translate | async}}</th>
                <!-- <th>Time in Repair</th> -->
                <th>{{'% Complete' | translate | async}}</th>
                <th>{{'Status' | translate | async}}</th>
                <th>{{'Total Hours ' | translate | async}}</th>
                <th>{{'Total Cost ' | translate | async}}</th>
                <!-- <th>SOW Approval Required</th> -->
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let imp of ImplementDetalisList">
                <tr  style="cursor: pointer;" (click)="openImplementDetails(imp.ImplementId)">
                    <!-- <td class="CelltextWrap columncell" title="{{imp.condition}}">
                        <span >
                            <div class="{{getEvalClass(imp.condition)}}"  style="width:25px">{{imp.condition}}%</div>
                        </span> </td> -->
                        <!-- [ngClass]="getApprovalColour(imp.Required, imp.Response)" -->
                    <td class="CelltextWrap columncell" title="{{imp.customer}}">{{imp.ImpType}}</td>
                    <td class="CelltextWrap columncell" title="{{imp.jobsite}}">{{imp.ImplementName}}</td>
                    <td class="columncell">{{imp.Model}}</td>
                    <td class="columncell">
                        <span  [ngClass]="getRequiredColour(imp.Required, imp.Response)">
                            <div>  {{imp.Required==true? ('Yes' | translate | async):('No' | translate | async)}} </div>
                        </span>
                    </td>
                    <td class="columncell">
                        <span  [ngClass]="getApprovalColour(imp.Required, imp.Response)">
                            <div>  {{imp.Response==null? ('N/A' | translate | async):imp.Response==true? ('Yes' | translate | async):('No' | translate | async)}} </div>
                        </span>
                    </td>
                    <td class="columncell">{{imp.StartDate}}</td>
                    <!-- <td class="columncell">Time in Repair</td> -->
                    <td class="columncell">{{imp.CompletePercent}}</td>
                    <td class="columncell">{{imp.Status | translate | async}}</td>
                    <td class="columncell">{{imp.totalHours}}</td>
                    <td class="columncell">{{imp.totalCost}}</td>
                    <!-- <td class="columncell">{{imp.SOWApprovalRequired}}</td> -->
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>